import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import ButtonBase from "@material-ui/core/ButtonBase";
// import routeThumb from "../../images/route_thumb.png";

const styles = theme => ({
  root: {
    margin: 5
  },
  thumbnail: {
    width: "45vw",
    borderRadius: "5%",
    border: `3px solid ${theme.palette.primary.dark}`
  },
  description: {
    width: "45vw",
    marginLeft: 10
  },
  value: {
    color: theme.palette.primary.dark
  }
});

class RouteTile extends Component {
  render() {
    const {
      classes,
      title,
      distance,
      onSelectRoute,
      routeKey,
      ambassadorKey,
      ambassador,
      description,
      climb
    } = this.props;

    const routeThumb = `/images/${ambassadorKey}/${routeKey}.png`;

    return (
      <ButtonBase
        className={classes.root}
        onClick={() => onSelectRoute(ambassadorKey + "/" + routeKey)}
      >
        <img
          className={classes.thumbnail}
          src={routeThumb}
          alt="Route thumbnail"
        />
        <div className={classes.description}>
          <h2>{title}</h2>
          <div>
            Afstand:<span className={classes.value}> {distance} Km</span>
          </div>
          {ambassador ? (
            <div>
              Ambassadeur:<span className={classes.value}> {ambassador}</span>
            </div>
          ) : null}
          {climb ? (
            <div>
              Totale klimafstand:<span className={classes.value}>
                {" "}
                {climb} m
              </span>
            </div>
          ) : null}
          {description ? <div>{description}</div> : null}
        </div>
      </ButtonBase>
    );
  }
}

RouteTile.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  distance: PropTypes.number.isRequired,
  onSelectRoute: PropTypes.func.isRequired,
  routeKey: PropTypes.string.isRequired,
  ambassadorKey: PropTypes.string.isRequired,
  ambassador: PropTypes.string,
  description: PropTypes.string,
  climb: PropTypes.number
};

export default withStyles(styles)(RouteTile);



// WEBPACK FOOTER //
// ./src/Ambassadors/atoms/RouteTile.js